
import React from 'react';
import styled from 'styled-components';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 85vh;
  background-color: ${({ theme }) => theme.background || '#ffffff'};
  color: ${({ theme }) => theme.text || '#333'};
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  text-align: center;
`;

const Title = styled.h1`
  font-size: 3rem;
  margin-bottom: 1rem;
`;

const Subtitle = styled.p`
  font-size: 1.25rem;
  color: #7f8c8d;
`;

const Cvc = () => {
  return (
    <Wrapper>
      <Title>🚧 Coming Soon</Title>
      <Subtitle>Upload information for Coaldale Veterinary Clinic is coming. Check back soon!</Subtitle>
    </Wrapper>
  );
};

export default Cvc;